var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "drop down icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "chevron down",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.43738 13.0592C4.15716 12.7759 4 12.3935 4 11.995C4 11.5964 4.15716 11.214 4.43738 10.9307L8.84602 6.48303C9.17303 6.16052 9.59604 6.00002 10.0146 6.00002C10.4331 6.00002 10.8486 6.16052 11.1681 6.48303L15.5632 10.9157C15.8431 11.1992 16 11.5816 16 11.9799C16 12.3783 15.8431 12.7607 15.5632 13.0442C15.4255 13.184 15.2613 13.295 15.0803 13.3708C14.8992 13.4465 14.7049 13.4856 14.5087 13.4856C14.3124 13.4856 14.1181 13.4465 13.9371 13.3708C13.7561 13.295 13.5919 13.184 13.4542 13.0442L10.0071 9.56863L6.54645 13.0592C6.40839 13.1985 6.24412 13.309 6.06313 13.3844C5.88213 13.4598 5.688 13.4987 5.49192 13.4987C5.29584 13.4987 5.1017 13.4598 4.9207 13.3844C4.73971 13.309 4.57544 13.1985 4.43738 13.0592Z",
    fill: "#FFF3E4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownArrow);
export default __webpack_public_path__ + "static/media/dropdown-arrow.35b77591aa2a74da3c6baf19a4626064.svg";
export { ForwardRef as ReactComponent };